import {ReactNode} from 'react'
import cn from 'clsx'
import {Space} from 'antd'

import styles from './CashflowPanel.module.scss'
import {Button} from 'common/components/V2'

interface CashflowPanelProps {
  children?: ReactNode
  margin?: 'small' | 'medium' | 'large'
  title: string
  reportDisabled?: boolean
  onReport?: () => void
}

export default function CashflowPanel({
  children,
  margin = 'medium',
  title,
  reportDisabled,
  onReport,
}: CashflowPanelProps) {
  return (
    <div
      className={cn(
        styles.root,
        styles[`root_margin_${margin}`],
        onReport && styles.root_grid
      )}
    >
      <Space className={styles.panel} size={10}>
        <h2 className={styles.title}>{title}</h2>
        {children}
      </Space>
      {onReport && (
        <Button $color='cyan' $size='small'
          disabled={reportDisabled} 
          onClick={onReport}
        >
          Create report
        </Button>
      )}
    </div>
  )
}
